import { createStatusPage } from "../utils/gsc";

// Opent de eigen PDF-bon van een case in een nieuw tabblad. Het tabblad gaat
// meteen bij de klik open (anders blokkeert de browser hem als pop-up na het
// laden/renderen) en toont zolang dezelfde wachtpagina als Print PDF.
export async function openCaseSummaryPdf(rowData) {
  const win = window.open("", "_blank");
  if (!win) {
    alert("Pop-up blocked. Please allow pop-ups for this site to view PDFs.");
    return;
  }
  const status = createStatusPage(win);
  status.update("Creating PDF");
  try {
    const { renderCaseSummaryPdf } = await import("./browser");
    const blob = await renderCaseSummaryPdf(rowData);
    const url = URL.createObjectURL(blob);
    if (win.closed) {
      URL.revokeObjectURL(url);
      return;
    }
    win.location.href = url;
    setTimeout(() => URL.revokeObjectURL(url), 60000);
  } catch (error) {
    console.error("Case summary PDF failed:", error);
    if (!win.closed) status.fail(error.message || String(error));
  }
}
